module.exports = __webpack_public_path__ + "static/favicon-16e0f0697ef47aeaf9debfd4078b02f6.png";